import ReactMarkdown, { type Components } from "react-markdown";
import remarkGfm from "remark-gfm";

// Les liens externes s'ouvrent dans un nouvel onglet : le lecteur est au
// milieu d'une procédure, il ne doit pas perdre sa page. Les ancres internes
// et les chemins relatifs restent dans l'onglet courant.
const components: Components = {
  a: ({ node: _node, href, children, ...rest }) => {
    const external = typeof href === "string" && /^https?:\/\//i.test(href);
    return (
      <a href={href} {...rest} {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}>
        {children}
      </a>
    );
  },
};

/** Rend un corps markdown (GFM : tableaux, listes à cocher, barré) dans un bloc `.md` stylé. */
export function Markdown({ body }: { body: string }) {
  if (!body.trim()) return <p className="md md--empty">Aucun contenu pour cette étape.</p>;
  return (
    <div className="md">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
        {body}
      </ReactMarkdown>
    </div>
  );
}
